import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { useParams } from 'react-router-dom';

const KycDetailsPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Детали KYC запроса
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Typography>
          Информация о KYC запросе с ID: {id} будет доступна после подключения к Hasura GraphQL API.
        </Typography>
      </Paper>
    </Box>
  );
};

export default KycDetailsPage; 